import MuiTooltip, { type TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip';

export type TooltipProps = MuiTooltipProps;

/**
 * A short hint on hover and keyboard focus, inverted against the scheme (dark in light mode, light
 * in dark mode). The child must accept a ref and stay enabled: wrap a disabled control in a span.
 */
export function Tooltip({ enterDelay = 300, placement = 'top', ...props }: TooltipProps) {
  return <MuiTooltip enterDelay={enterDelay} placement={placement} {...props} />;
}
